import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export const RoboxLeaderboard = () => {
  const { L } = useLang();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/robox/leaderboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 mt-10" data-testid="robox-leaderboard">
      <div className="rounded-2xl bg-[#0A192F] text-white p-6 sm:p-8 grid md:grid-cols-[1fr_1.2fr] gap-6 items-start">
        <div>
          <div className="flex items-center gap-2 text-[#FFD166] font-bold text-sm"><Trophy className="w-4 h-4" />{L("Top Robo-X sharers", "टॉप Robo-X शेयरर्स")} · {d.month}</div>
          <h3 className="mt-2 text-2xl font-black font-['Outfit']">{L("Share your licence code, get 7 free days", "अपना लाइसेंस कोड शेयर करें, 7 दिन मुफ़्त पाएँ")}</h3>
          <p className="mt-2 text-sm text-slate-300">{L(`Every friend who buys Robo-X with your code adds ${d.bonus_days} days of unlocked trading to your app. Find your code at /robox.`, `आपके कोड से Robo-X खरीदने वाला हर दोस्त आपके ऐप में ${d.bonus_days} दिन जोड़ता है। अपना कोड /robox पर देखें।`)}</p>
        </div>
        {d.leaders.length ? (
          <ol className="space-y-2" data-testid="robox-leaderboard-list">{d.leaders.map((l) => (
            <li key={l.rank} className="flex items-center gap-3 rounded-xl bg-white/5 px-4 py-2.5" data-testid={`robox-leader-${l.rank}`}>
              <span className={`w-7 h-7 rounded-full grid place-items-center text-sm font-black ${l.rank === 1 ? "bg-[#FFD166] text-[#0A192F]" : "bg-white/10"}`}>{l.rank}</span>
              <span className="flex-1 font-semibold">{l.name}</span>
              <span className="text-sm text-[#FFD166] font-bold">{l.referrals} {L(l.referrals === 1 ? "friend" : "friends", "दोस्त")}</span>
            </li>))}</ol>
        ) : <p className="text-sm text-slate-300 rounded-xl bg-white/5 p-4" data-testid="robox-leaderboard-empty">{L("No sharers yet this month — be the first!", "इस महीने अभी कोई नहीं — पहले बनें!")}</p>}
      </div>
    </section>
  );
};
